import './Workcardstyle.css';
import React from 'react';
import WorkCard from './WorkCard';
import WorkData from './Workdata';

const Work = () => {
return (
    <div className='Work-container'>
        <h1 className='project-heading'>PROJECTS</h1>
        <h3 className='project-heading text-white'>MUSIC</h3>
        <div className='project-container'>
            {WorkData.map((value, index) => {
                return (
                    <WorkCard
                    key={index} 
                    imagesource={value.imagesource}
                    title={value.title}
                    text={value.text}
                    Spotify={value.Spotify}
                    Apple={value.Apple}
                    />
                )
            })}
    </div>

    </div>
);
};

export default Work;